import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import ContactSectionContactsWhitePattern4 from '../components/contacts-white-pattern/ContactSectionContactsWhitePattern4';

const meta = {
  title: 'Contact Us | Bagga International',
  meta: [
    { name: 'description', content: 'Get in touch with Bagga International for product inquiries, support, or partnership opportunities.' },
    { property: 'og:title', content: 'Contact Us | Bagga International' },
    { property: 'og:description', content: 'Get in touch with Bagga International for product inquiries, support, or partnership opportunities.' },
    { property: 'og:image', content: '/images/site-default-og.jpg' },
    { property: 'og:type', content: 'website' },
    { property: 'og:url', content: 'https://baggainternational.com/contact' },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: 'Contact Us | Bagga International' },
    { name: 'twitter:description', content: 'Get in touch with Bagga International for product inquiries, support, or partnership opportunities.' },
    { name: 'twitter:image', content: '/images/site-default-og.jpg' }
  ],
  link: [
    { rel: 'canonical', href: 'https://baggainternational.com/contact' }
  ],
  style: [],
  script: [],
};

export default function Contact() {
  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <ContactSectionContactsWhitePattern4 />
    </React.Fragment>
  );
}

